/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { nodeProvidersGetApiV3NodeProvidersCount } from "../../funcs/nodeProvidersGetApiV3NodeProvidersCount.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NodeProvidersCountRequest$inboundSchema
    .optional(),
};

export const tool$nodeProvidersGetApiV3NodeProvidersCount: ToolDefinition<
  typeof args
> = {
  name: "node-providers-get-api-v3-node-providers-count",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await nodeProvidersGetApiV3NodeProvidersCount(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
